import React from 'react';
import { SvgIcon } from '@material-ui/core';

const AddCircleIcon = (props) => (
  <SvgIcon
    width="27.001"
    height="27.002"
    viewBox="0 0 27.001 27.002"
    {...props}
  >
    <path
      data-name="Add circle icon"
      d="M-6784.5,21899a13.406,13.406,0,0,1-9.543-3.957,13.415,13.415,0,0,1-3.955-9.547,13.4,13.4,0,0,1,3.955-9.543,13.4,13.4,0,0,1,9.543-3.955,13.408,13.408,0,0,1,9.548,3.955,13.4,13.4,0,0,1,3.955,9.543,13.407,13.407,0,0,1-3.955,9.547A13.413,13.413,0,0,1-6784.5,21899Zm-5.5-14a1,1,0,0,0-1,1,1,1,0,0,0,1,1h5v5a1,1,0,0,0,1,1,1,1,0,0,0,1-1v-5h5a1,1,0,0,0,1-1,1,1,0,0,0-1-1h-5v-5a1,1,0,0,0-1-1,1,1,0,0,0-1,1v5Z"
      transform="translate(6797.999 -21872)"
    />
  </SvgIcon>
);

export default AddCircleIcon;
